import { render } from "./DownloadNotifications.vue?vue&type=template&id=2703d2da&scoped=true"
import script from "./DownloadNotifications.vue?vue&type=script&lang=js"
export * from "./DownloadNotifications.vue?vue&type=script&lang=js"

import "./DownloadNotifications.vue?vue&type=style&index=0&id=2703d2da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2703d2da"]])

export default __exports__